/**
 * Shopify Subscriptions app block — format widget prices to match theme:
 * "75 EUR" / "75,00 EUR" → "€ 75"
 */
(function () {
  'use strict';

  var ROOT_SELECTOR = '.shopify_subscriptions_app_block';
  var PRICE_SELECTOR = [
    '.shopify_subscriptions_in_widget_price',
    '.shopify_subscriptions_app_block [class*="price"]',
    '.shopify_subscriptions_app_block s',
    '.shopify_subscriptions_app_block del'
  ].join(', ');

  function formatPriceText(text) {
    if (!text) return text;
    var next = text;

    // 75 EUR / 75,00 EUR → € 75 / € 75,00
    next = next.replace(/(\d+(?:[.,]\d+)?)\s*EUR\b/gi, '€ $1');
    // EUR 75 (rare) → € 75
    next = next.replace(/\bEUR\s*(\d+(?:[.,]\d+)?)/gi, '€ $1');

    // € 75,00 / € 75.00 → € 75
    next = next.replace(/(\d)([.,])00(?!\d)/g, '$1');

    return next;
  }

  function walkTextNodes(root, fn) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      fn(node);
    }
  }

  function applyToElement(el) {
    if (!el) return;

    walkTextNodes(el, function (textNode) {
      var next = formatPriceText(textNode.nodeValue);
      if (next !== textNode.nodeValue) textNode.nodeValue = next;
    });
  }

  function formatAll(root) {
    var scope = root || document;
    var blocks = scope.querySelectorAll
      ? scope.querySelectorAll(ROOT_SELECTOR)
      : [];

    if (!blocks.length && scope.matches && scope.matches(ROOT_SELECTOR)) {
      blocks = [scope];
    }

    Array.prototype.forEach.call(blocks, function (block) {
      var priceNodes = block.querySelectorAll(PRICE_SELECTOR);
      if (priceNodes.length) {
        Array.prototype.forEach.call(priceNodes, applyToElement);
      } else {
        applyToElement(block);
      }
    });
  }

  function init() {
    var blocks = document.querySelectorAll(ROOT_SELECTOR);
    if (!blocks.length) return;

    formatAll(document);

    var observer = new MutationObserver(function () {
      formatAll(document);
    });

    Array.prototype.forEach.call(blocks, function (block) {
      observer.observe(block, {
        childList: true,
        subtree: true,
        characterData: true
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
